import { render, staticRenderFns } from "./ViewContract.vue?vue&type=template&id=97773e3a&"
import script from "./ViewContract.vue?vue&type=script&lang=js&"
export * from "./ViewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports